// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"410a4c3a","429":"410a4c3a","748":"86a836db","985":"410a4c3a"}[chunkId] + ".chunk.css";
};